const VIDEO = 'video';
const IMAGE = 'image';

const allowed_formats = {
  [VIDEO]: ['mp4'],
  [IMAGE]: ['png', 'jpeg', 'avif', 'jpg', 'gif', 'webp'],
};

export const config = {
  [IMAGE]: {
    maxSize: 5,
    allowedFormat: allowed_formats[IMAGE],
  },
  [VIDEO]: {
    maxSize: 50,
    allowedFormat: allowed_formats[VIDEO],
  },
};

export const mediaUtils = {
  getSize: function (file) {
    return file.size;
  },

  getMediaType: function (file) {
    const type = file.type.split('/')[0];
    if (type) return type;
    return '';
  },

  getMediaExtension: function (file) {
    const type = file.type.split('/')[1];
    if (type) return type;
    return '';
  },

  exceedMaxSize: function (file) {
    const type = this.getMediaType(file);
    if (config[type] !== undefined) {
      return this.getSize(file) >= config[type].maxSize * 1024 * 1024;
    }
    return true;
  },

  supportsFormat: function (file) {
    const type = this.getMediaType(file);
    const ext = this.getMediaExtension(file);
    if (config[type] !== undefined) {
      return config[type].allowedFormat.includes(ext);
    }
    return false;
  },

  isImage: function (file) {
    return this.getMediaType(file) === 'image';
  },

  isVideo: function (file) {
    return this.getMediaType(file) === 'video';
  },
};
